import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Input } from '@/components/ui/input';

interface UserNameFilterProps {
  filterIndex: number;
}

/**
 * Renders a text input for filtering sessions by user name
 */
export const UserNameFilter = ({ filterIndex }: UserNameFilterProps) => {
  const { t } = useTranslation();
  const { getValues, control } = useFormContext();

  const { update } = useFieldArray({ control, name: 'filters' });

  const userName = useWatch({ control, name: `filters.${filterIndex}.userName` }) || '';

  const handleUserNameChange = (value: string) => {
    const currentFilter = getValues(`filters.${filterIndex}`);
    update(filterIndex, { ...currentFilter, userName: value });
  };

  return (
    <Input
      id={`user-name-${filterIndex}`}
      type="text"
      placeholder={t('analytics.filters.userNamePlaceholder')}
      value={userName}
      onChange={(e) => handleUserNameChange(e.target.value)}
      className="w-full"
    />
  );
};
